import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';


@Injectable({providedIn: 'root'})
export class AnnotationsService extends ApiService {
  public eventEmitter = new EventEmitter();
  public getAnnotations(param): Observable<any> {
    return this.request({
      path: 'annotation-types/',
      method: 'GET',
      query: param
    });
  }

  public deleteAnnotations(id): Observable<any> {
    return this.request({
      path: `annotation-types/${id}`,
      method: 'DELETE'
    });
  }

  public updateAnnotation(data, id): Observable<any> {
    return this.request({
      path: `annotation-types/${id}`,
      method: 'PUT',
      body: data
    });
  }

  public create(data): Observable<any> {
    return this.request({
      path: 'annotation-types',
      method: 'POST',
      body: data
    });
  }

  public getAnnotationById(id): Observable<any> {
    return this.request({
      path: `annotation-types/${id}`,
      method: 'GET'
    });
  }

}
